import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui-v2';
import 'element-theme-v2';
import '@/assets/common.scss'

Vue.config.productionTip = false

Vue.use(ElementUI);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
